import { handleError } from '@/errorHandler';
import axios from '@/services/AxiosConfig';
import { getGlobalToast } from '@/toast';

const API_URL = 'dashboard';

class InboxService {
  async getUnreadCounts() {
    const res = await axios.get(`${API_URL}/unread-counts`);
    return res.data;
  }

  async getFormSubmitted(params = {}) {
    try {
      const res = await axios.get(`${API_URL}/form-submitted`, { params });
      return res.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  }

  async getAccountByProvince(params = {}) {
    try {
      const res = await axios.get(`${API_URL}/account-by-province`);
      return res.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  }

  async getAccountRegister(params = {}) {
    try {
      const res = await axios.get(`${API_URL}/account-register`, { params });
      return res.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  }

  async getTotalAds(params = {}) {
    try {
      const res = await axios.get(`${API_URL}/ads-distribution`, { params });
      return res.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  }
}

export default new InboxService();
